module.exports = __webpack_public_path__ + "img/Small-Bevel-Attachment-47.ab65c64f.png";